import React from 'react';
import ReactDOM from 'react-dom/client';
// viem and WalletConnect use Node's Buffer in browser code paths.
// This polyfill must be the first import so it's available before any wallet code runs.
import { Buffer } from 'buffer';
if (typeof globalThis.Buffer === 'undefined') {
  (globalThis as any).Buffer = Buffer;
}
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ClientProviders from '@/components/ClientProviders';
import Router from './Router';
import './globals.css';

// P0-14 + P0-20: Vite + SEO/GEO-ready entry point.
// HelmetProvider wraps everything so <SEO> components can update <head> per route.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ClientProviders>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </ClientProviders>
    </HelmetProvider>
  </React.StrictMode>,
);
